const formatDateInput = (startDate, endDate, defaultText) => {
  if (!startDate || !endDate) return defaultText;
  const start = new Date(startDate);
  const end = new Date(endDate);

  return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
};

export { formatDateInput };
